var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('section',{staticClass:"hero is-light is-fullheight"},[_c('div',{staticClass:"hero-body is-flex is-justify-content-center"},[_c('div',{staticClass:"box"},[_c('router-view')],1)])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }